import { z } from 'zod';

import { ErrorResponse } from './common.js';

export const ConnectionQuerySchema = z.object({
  platform: z.string(),
});

export const BffConnectionsQuerySchema = z.object({
  platform: z.string(),
  cache: z.string(),
});

export const ConnectionSchema = z.object({
  id: z.string(),
  name: z.string(),
  companyId: z.number(),
  platform: z.string(),
  expired: z.boolean(),
  usingInAccounts: z.boolean(),
  amazonRegion: z.string().nullable(),
  userUpdatedAt: z.string().nullable(),
  userUpdatedId: z.coerce.string().nullable(),
  userUpdatedName: z.string().nullable().optional(),
  partnerId: z.string().nullable().optional(),
  adAccountCount: z.number().nullable().optional(),
});

export const ConnectionSchemaV2 = z.object({
  id: z.string(),
  name: z.string(),
  platform: z.string(),
  expired: z.boolean(),
  userUpdatedAt: z.string().nullable(),
  userUpdatedName: z.string().nullable().optional(),
  connectedAccountsCount: z.string().nullable().optional(),
});

export const ConnectionsResponseDataSchema = z.object({
  data: z.object({
    items: z.array(ConnectionSchema),
  }),
  error: ErrorResponse.optional(),
});

export const BffConnectionsResponseDataSchema = z.object({
  data: z
    .object({
      items: z.array(ConnectionSchema).nullable(),
    })
    .nullable(),
  error: z.object({ message: z.string() }).nullable(),
});

export const ConnectionsResponseDataSchemaV2 = z.object({
  data: z
    .object({
      items: z.array(ConnectionSchemaV2),
    })
    .nullable(),
  meta: z
    .object({
      summary: z.object({
        connectedPlatforms: z.number(),
        connectedAdAccounts: z.number(),
        expiredConnections: z.number(),
      }),
    })
    .optional(),
  error: z.object({ message: z.string() }).nullable(),
});

export const UpdateConnectionRequestSchema = z.object({
  name: z.string(),
  region: z.string().nullable().optional(),
});

export const VerifyConnectionResponseSchema = z.object({
  data: z
    .object({
      items: z.array(z.object({ verified: z.boolean() })),
    })
    .optional(),
  error: ErrorResponse.optional(),
});
